/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function MapPinFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="map-pin-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M12.489 2.684C12.922 2.726 13.034 2.726 13.461 2.809C14.439 2.998 15.378 3.38 16.209 3.929C16.931 4.406 17.57 5.005 18.094 5.693C18.501 6.228 18.837 6.817 19.09 7.44C19.521 8.504 19.707 9.663 19.634 10.808C19.572 11.793 19.318 12.764 18.888 13.653C18.515 14.422 18.012 15.123 17.409 15.728C15.61 17.535 13.803 19.334 12 21.137C10.197 19.334 8.39 17.535 6.591 15.728C5.87 15.004 5.294 14.144 4.91 13.197C4.167 11.366 4.167 9.271 4.91 7.44C5.228 6.657 5.677 5.929 6.233 5.292C6.799 4.644 7.473 4.09 8.222 3.665C9.083 3.174 10.04 2.857 11.023 2.731C11.347 2.69 11.674 2.669 12 2.669C12.163 2.669 12.326 2.679 12.489 2.684ZM14.655 7.663C14.017 7.025 12.983 6.563 12 6.563C11.017 6.563 9.983 7.025 9.345 7.663C8.706 8.302 8.245 9.336 8.245 10.319C8.245 11.302 8.706 12.336 9.345 12.974C9.983 13.613 11.017 14.074 12 14.074C12.983 14.074 14.017 13.613 14.655 12.974C15.294 12.336 15.755 11.302 15.755 10.319C15.755 9.336 15.294 8.302 14.655 7.663Z" data-tinysvg-shape="compound-path" fillRule="evenodd" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M6.591 15.728C3.603 12.741 3.603 7.897 6.591 4.909C9.578 1.922 14.422 1.922 17.409 4.909C20.397 7.897 20.397 12.741 17.409 15.728L12 21.137L6.591 15.728Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
